import { Component, inject, OnInit } from '@angular/core';
import { PrivilegeLevels } from './roles';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import {
  IcsAppLogoComponent,
  IcsDesktopAppComponent,
  IcsSidenavToolsComponent,
} from 'ics-core';
import { IcsAuthenticationMenuComponent } from 'ics-identity-authentication';
import { injectActiveAuthenticator } from '@ics-cdk/authentication';
import { HistoryHandleComponent } from './components';
import { UnLockButtonComponent } from './lock/un-lock-button/un-lock-button.component';
import { IcsMessengerToolsComponent } from '@ics-angular/messenger';
import { NeedsAuthorizationDirective } from '@ics-cdk/core/authorization';
import { AppDownloadButtonComponent } from './buttons';

@Component({
  selector: 'app-root',
  imports: [
    IcsDesktopAppComponent,
    IcsAppLogoComponent,
    RouterLink,
    IcsSidenavToolsComponent,
    IcsAuthenticationMenuComponent,
    HistoryHandleComponent,
    UnLockButtonComponent,
    IcsMessengerToolsComponent,
    RouterOutlet,
    NeedsAuthorizationDirective,
    AppDownloadButtonComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _activatedRoute = inject(ActivatedRoute);

  title = 'ICS-TLS';

  ngOnInit() {
    this.checkLogin();
  }

  private checkLogin() {
    // reading whole url
    const url = window.location.href;
    // check if url is mentioned for auth-callback and has a token
    if (url.includes('auth-callback') && url.includes('token')) {
      // splitting token from complete url
      const urlSplit = url.split('auth-callback');
      const loginToken = urlSplit[urlSplit.length - 1];
      // double check if token was found
      if (loginToken.includes('token')) {
        // re-direct to auth-callback to do it the right way
        this._router.navigate(['auth-callback'], {
          relativeTo: this._activatedRoute,
          fragment: loginToken,
        });
      }
    }
  }

  protected readonly PrivilegeLevels = PrivilegeLevels;
}
